<template>
  <div class="region">
    <mtd-icon name="mtdicon-location-o" class="region-icon"></mtd-icon>
    <span class="region-text">{{ regionStr }}</span>
  </div>
</template>
<script>
import { RegionReader } from '@osgfe/web-region-store';

export default {
  name: "McRegion",
  inject: ['$$event'],
  data() {
    return {
      regionStr: '',
    };
  },
  mounted() {
    // 兜底：若 regionStoreReady 已在组件挂载前 emit（RegionStore 已有数据），则主动初始化
    const curRegion = RegionReader.getCurRegion(false)?.code;
    if (curRegion) {
      this.initRegion();
    }
  },
  methods: {
    initRegion() {
      this.regionStr = RegionReader.getCurRegion(false)?.name;
    },
  },
};
</script>
<style lang="scss" scoped>
.region {
  color: #111925;
  display: flex;
  align-items: center;
  margin-inline-end: 24px;
  .region-icon {
    vertical-align: middle;
    font-size: 20px;
  }
  .region-text {
    margin: 0 4px;
    font-size: 14px;
  }
}
</style>
